import React from 'react';
import { Target, KeySquare, Palette, Sparkles } from 'lucide-react';

const steps = [
  {
    icon: Target,
    title: 'Choose Your Genre',
    description: 'Select from fiction, non-fiction, academic, or children\'s books.'
  },
  {
    icon: KeySquare,
    title: 'Add Keywords',
    description: 'Customize your title with keywords that represent your book\'s theme.'
  },
  {
    icon: Palette,
    title: 'Generate Titles',
    description: 'Our AI creates unique book titles based on your choices.'
  },
  {
    icon: Sparkles,
    title: 'Pick Your Favorite',
    description: 'Choose the perfect title that captures your book\'s essence.'
  }
];

export default function BookHowItWorks() {
  return (
    <section className="py-20 bg-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          How Our Book Title Generator Works
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-purple-200"></div>
              )}
              <div className="relative text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-purple-100 mb-4">
                  <step.icon className="w-8 h-8 text-purple-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}